<template>
  <div class="view-wrapper view-wrapper-master-overlay">
    <div class="view view-master-full">
      <v-toolbar class="my-bar">
        <v-dialog v-model="dialog" max-width="500px" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>filter_alt</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">Фильтр</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filter.organizationId"
                      :items="ctx.src.org.byType(['3', '4'])"
                      :label="'Организация'"
                      item-text="fullName"
                      item-value="id"
                      clearable
                      @keydown.enter="fetchFiltered"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filter.underwriterId"
                      :items="ctx.src.org.byType('1')"
                      :label="'Страховая'"
                      item-text="fullName"
                      item-value="id"
                      clearable
                      @keydown.enter="fetchFiltered"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filter.categoryId"
                      :items="ctx.src.categories.items"
                      :label="'Категория услуг'"
                      item-text="name"
                      item-value="id"
                      clearable
                      @keydown.enter="fetchFiltered"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filter.serviceId"
                      :items="
                        filter.categoryId
                          ? ctx.src.services.byCategory(filter.categoryId)
                          : ctx.src.services.list()
                      "
                      :label="'Услуга'"
                      item-text="name"
                      item-value="id"
                      clearable
                      @keydown.enter="fetchFiltered"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="filter.date"
                      label="Актуальные на дату"
                      type="date"
                      required
                      @keydown.enter="fetchFiltered"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-btn text @click="resetFilter">
                Сбросить
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false">
                Отмена
              </v-btn>
              <v-btn color="primary" text @click="fetchFiltered">
                Ок
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn icon @click="init">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn v-if="rightFilter('w')" icon @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="rightFilter('d')"
          icon
          :disabled="!item || !item.id"
          @click="rem"
        >
          <v-icon>remove</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-dialog v-if="rightFilter('w')" v-model="updateDatesDialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>event</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Изменение дат прайс-листов</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="updateDatesForm.organizationId"
                      :items="ctx.src.org.byType(['3', '4'])"
                      label="Организация"
                      item-text="fullName"
                      item-value="id"
                      clearable
                      required
                      :rules="[v => !!v || 'Необходимо выбрать организацию']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="updateDatesForm.startDate"
                      label="Действует с"
                      type="date"
                      required
                      :rules="[v => !!v || 'Необходимо указать дату начала']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="updateDatesForm.endDate"
                      label="Действует по"
                      type="date"
                      required
                      :rules="[v => !!v || 'Необходимо указать дату окончания']"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeUpdateDatesDialog">
                Отмена
              </v-btn>
              <v-btn 
                color="primary" 
                text 
                :loading="updateDatesLoading"
                :disabled="!updateDatesForm.organizationId || !updateDatesForm.startDate || !updateDatesForm.endDate"
                @click="updateDatesForOrganization"
              >
                Применить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <PriceImport v-if="rightFilter('w')" :vm="this"></PriceImport>
        <v-btn icon color="primary" :loading="loading" @click="exp">
          <v-icon>cloud_download</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        show-select
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
        @click:row="rowClick"
      >
        <template v-slot:item.visitDate="{ item }">
          <span>{{ item.visitDate | dateLocalFilter }}</span>
        </template>
        <template v-slot:item.actionDate="{ item }">
          <span>{{ item.actionDate | dateLocalFilter }}</span>
        </template>
      </v-data-table>
    </div>
    <div v-if="item" class="view-detail-overlay">
      <v-toolbar class="my-bar">
<!--        <v-btn v-if="rightFilter('w')" icon @click="save">
          <v-icon>save</v-icon>
        </v-btn>-->
        <SaveButton
        :handler="save"
        ></SaveButton>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="my-content">
        <Detail></Detail>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "../utils/fetch";
import Detail from "../components/prices/Detail";
import dateIsoFilter from "../filters/dateIso.filter";
import js2vm from "../utils/js2vm";
import ctx from "@/ctx";
import dateLocalFilter from "../filters/dateLocal.filter";
import vm2js from "../utils/vm2js";
import PriceImport from "../components/prices/PriceImport";
import rightFilter from "../filters/right.filter";
import SaveButton from "@/components/ButtonFacade";
let Filter = function() {
  let self = this;

  self.organizationId = undefined;
  self.underwriterId = undefined;
  self.categoryId = undefined;
  self.serviceId = undefined;

  self.date = dateIsoFilter(new Date());

  self.insuredId = undefined;
};

let Item = function(d) {
  let self = this;

  d.organization = d.organizationId;
  d.startDate4List = d.startDate;
  d.endDate4List = d.endDate;
  d.category = d.categoryId;
  d.service = d.serviceId;

  self.underwriter2vm = function(val) {
    return ctx.src.org.first(val);
  };
  self.organization2vm = function(val) {
    return ctx.src.org.first(val);
  };

  self.startDate2vm = function(val) {
    return dateIsoFilter(val);
  };
  self.endDate2vm = function(val) {
    return dateIsoFilter(val);
  };

  self.startDate4List2vm = function(val) {
    return dateLocalFilter(val);
  };
  self.endDate4List2vm = function(val) {
    return dateLocalFilter(val);
  };

  self.category2vm = function(val) {
    return ctx.src.categories.get(val);
  };
  self.service2vm = function(val) {
    return ctx.src.services.get(val);
  };

  js2vm(self, d);
};

export default {
  data: () => ({
    ctx,
    rightFilter,
    currentPage: 0,
    totalPages: 0,
    selected: [],
    loading: false,
    headers: [
      { text: "Компания", sortable: false, value: "organization.fullName" },
      { text: "Категория", sortable: false, value: "category.name" },
      { text: "Услуга", sortable: false, value: "service.name" },
      { text: "Сумма", sortable: false, align: "right", value: "amount" },
      {
        text: "Количество",
        sortable: false,
        align: "right",
        value: "quantity"
      },
      { text: "Действует с", sortable: false, value: "startDate4List" },
      { text: "Действует по", sortable: false, value: "endDate4List" }
    ],
    items: [],
    item: undefined,
    filter: new Filter(),
    dialog: false,
    byPages: true,
    updateDatesDialog: false,
    updateDatesForm: {
      organizationId: undefined,
      startDate: undefined,
      endDate: undefined
    },
    updateDatesLoading: false
  }),
  watch: {
    selected: function(val) {
      if (val.length === 0) this.item = undefined;
      else this.item = val[0];
    }
  },
  methods: {
    normalizeDate(value) {
      if (!value) return null;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      date.setHours(0, 0, 0, 0);
      return date;
    },
    isActivePriceItem(item) {
      const checkDate = this.normalizeDate(this.filter.date || new Date());
      if (!checkDate) return true;

      const activeTo = this.normalizeDate(item.activeTo);
      if (activeTo && activeTo < checkDate) return false;

      return true;
    },
    hasServiceName(item) {
      const name = item.service && item.service.name;
      return name != null && String(name).trim() !== "";
    },
    pushPriceItem(row) {
      const item = new Item(row);
      if (this.hasServiceName(item) && this.isActivePriceItem(item)) {
        this.items.push(item);
      }
    },
    resetFilter() {
      this.filter = new Filter();
    },
    async exp() {
      this.exporting = true;
      try {
        const res = await fetch.post(
          "/api/accounting/price-list/export",
          vm2js(this.filter)
        );
        if (res) {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(await res.blob);
          link.download = res.filename;
          link.click();
        }
      } finally {
        this.exporting = false;
      }
    },
    add() {
      this.close();
      this.selected.push(new Item({}));
    },
    async rem() {
      const res = await fetch.post(
        "/api/accounting/price-list/delete?id=" + this.item.id
      );
      if (res) {
        const index = this.items.indexOf(this.item);
        this.close();
        if (index !== -1) {
          this.items.splice(index, 1);
        }
      }
    },
    async save() {
      const res = await fetch.post(
        "/api/accounting/price-list/save",
        vm2js(this.item)
      );
      if (res) {
        if (this.item.id) {
          const index = this.items.findIndex(i => i.id === this.item.id);
          if (index !== -1) {
            const updated = new Item(vm2js(this.item));
            if (this.hasServiceName(updated) && this.isActivePriceItem(updated)) {
              this.items.splice(index, 1, updated);
            } else {
              this.items.splice(index, 1);
            }
          }
        } else {
          this.item.id = res;
          const item = new Item(vm2js(this.item));
          if (this.hasServiceName(item)) {
            this.items.unshift(item);
          }
        }
        this.close();
        await ctx.src.prices.init();
      }
    },
    close() {
      this.selected = [];
    },
    handleScroll(e) {
      if (!this.byPages) return;
      if (
        e.target.scrollTop >=
        (e.target.scrollHeight - e.target.offsetHeight) * 0.9
      ) {
        if (this.totalPages - 1 > this.currentPage) {
          this.currentPage++;
          const params = {
            page: this.currentPage
          };
          this.fetchItems(params);
        }
      }
    },
    rowClick(obj, row) {
      if (!row.isSelected) row.select(obj);
      else this.selected = [];
    },
    async fetchItems(params) {
      this.loading = true;
      await ctx.src.services.init();
      const activeTo = encodeURIComponent(this.filter.date);
      let res = await fetch.get(
        "/api/accounting/price-list/get-list?page=" + params.page + "&activeTo=" + activeTo
      );
      if (res.first) this.totalPages = res.totalPages;
      (res.content || []).forEach(r => {
        this.pushPriceItem(r);
      });
      this.loading = false;
    },
    async fetchFiltered() {
      this.close();
      this.loading = true;
      this.items = [];
      this.byPages = false;
      this.dialog = false;
      await ctx.src.services.init();
      const payload = {
        ...vm2js(this.filter),
        activeTo: this.filter.date
      };
      let res = await fetch.post(
        "/api/accounting/price-list/get-list",
        payload
      );
      if (res) {
        res.forEach(element => {
          this.pushPriceItem(element);
        });
      }
      this.loading = false;
    },
    async resetPages() {
      this.byPages = true;
      this.currentPage = 0;
      this.totalPages = 0;
      this.selected = [];
      this.items = [];
    },
    async init() {
      this.loading= true;
      await this.ctx.src.services.init();
      await this.resetPages();
      await this.fetchItems({page: 0});

      this.loading = false;
    },
    closeUpdateDatesDialog() {
      this.updateDatesDialog = false;
      this.updateDatesForm = {
        organizationId: undefined,
        startDate: undefined,
        endDate: undefined
      };
    },
    async updateDatesForOrganization() {
      if (!this.updateDatesForm.organizationId || !this.updateDatesForm.startDate || !this.updateDatesForm.endDate) {
        return;
      }
      
      this.updateDatesLoading = true;
      
      try {
        // Получаем все прайс-листы для выбранной организации
        // Используем тот же формат фильтра, что и в fetchFiltered
        const filter = new Filter();
        filter.organizationId = this.updateDatesForm.organizationId;
        
        console.log("Фильтр для запроса:", vm2js(filter));
        console.log("ID организации:", this.updateDatesForm.organizationId);
        
        let priceLists = await fetch.post(
          "/api/accounting/price-list/get-list",
          vm2js(filter)
        );
        
        console.log("Полученные прайс-листы (через фильтр):", priceLists);
        
        // Если не получили через фильтр, попробуем получить все и отфильтровать на клиенте
        if (!priceLists || priceLists.length === 0) {
          console.log("Попытка получить все прайс-листы и отфильтровать на клиенте...");
          // Получаем все прайс-листы из текущего списка
          // organizationId может быть как числом, так и через объект organization
          const allPriceLists = this.items.filter(item => {
            const orgId = item.organizationId || (item.organization && item.organization.id);
            return orgId === this.updateDatesForm.organizationId;
          });
          
          if (allPriceLists.length > 0) {
            console.log("Найдено прайс-листов в текущем списке:", allPriceLists.length);
            // Преобразуем обратно в простые объекты для отправки
            priceLists = allPriceLists.map(item => vm2js(item));
          } else {
            console.log("Прайс-листы не найдены для организации:", this.updateDatesForm.organizationId);
            alert("Прайс-листы не найдены для выбранной организации. Убедитесь, что для этой организации есть записи в таблице.");
            this.updateDatesLoading = false;
            return;
          }
        }
        
        // Обновляем даты для всех прайс-листов
        const updatedLists = priceLists.map(list => ({
          ...list,
          startDate: this.updateDatesForm.startDate,
          endDate: this.updateDatesForm.endDate
        }));
        
        console.log("Обновленный список для сохранения:", updatedLists);
        console.log("Количество элементов для сохранения:", updatedLists.length);
        console.log("Первые 3 элемента для примера:", updatedLists.slice(0, 3));
        
        // Отправляем обновленный список на сохранение
        console.log("Отправка запроса на сохранение...");
        
        try {
          const res = await fetch.post(
            "/api/accounting/price-list/save-list",
            updatedLists
          );
          
          console.log("Результат сохранения:", res);
          console.log("Тип результата:", typeof res);
          
          // Эндпоинт возвращает void, поэтому при успехе processingResponse вернет true (default case)
          // При ошибке будет выброшено исключение или вернется undefined/false
          if (res !== false && res !== undefined) {
            console.log("Сохранение успешно! Закрываем диалог и обновляем список...");
            this.closeUpdateDatesDialog();
            await this.init();
          } else {
            console.error("Ошибка при сохранении: результат", res);
            alert("Ошибка при сохранении. Проверьте консоль для подробностей.");
          }
        } catch (saveError) {
          console.error("Исключение при сохранении:", saveError);
          alert("Произошла ошибка при сохранении: " + saveError.message);
        }
      } catch (error) {
        console.error("Ошибка при обновлении дат:", error);
      } finally {
        this.updateDatesLoading = false;
      }
    }
  },
  async mounted() {
    await ctx.src.services.init();
    document
      .getElementsByClassName("v-data-table__wrapper")[0]
      .addEventListener("scroll", this.handleScroll);
    await this.fetchItems({ page: 0 });
  },
  components: {
    SaveButton,
    Detail,
    PriceImport
  }
};
</script>
